import { h } from "vue";
import { dayjs } from "element-plus";

import { createIntl, createIntlCache } from "@formatjs/intl";

const intl = createIntl(
  {
    locale: "zh-CN",
    messages: {},
  },
  createIntlCache(),
);

/**金额格式化 */
export const priceFormat = (num, n = 2) => {
  return intl.formatNumber(num, {
    minimumFractionDigits: n,
  });
};

export const numberFormat = (value) => {
  return priceFormat(value, 0);
};

//关键字高亮
export const tab_Highlinght = (text, key) => {
  if (text != null && text != undefined) {
    let reg = new RegExp("(" + key + ")", "g");
    let newStr = text
      .toString()
      .replace(reg, "<font style='color:#f00'>$1</font>");
    return h("text", { innerHTML: newStr });
  }
};

//状态字段格式化，添加颜色
export const tab_StatusFormat = (row, column, cellValue) => {
  return cellValue
    ? h("text", { style: "color:" + cellValue.Color }, cellValue.Text)
    : "-";
};

//内容格式化，如果为空则显示"-"
export const tab_TextFormat = (row, column, cellValue) => {
  return cellValue || "-";
};

//内容格式化，如果为空则显示"-"
export const tab_ShortDateFormat = (row, column, cellValue) => {
  return cellValue ? dayjs(cellValue).format("YYYY-MM-DD") : "-";
};

//组合内容格式化
export const tab_GroupFormat = (value1, value2, style1, style2) => {
  let str =
    "<text style='" +
    style1 +
    ";white-space: nowrap;font-size:95%'>" +
    value1 +
    "</text><br /><text style='color:#a2a2a2;" +
    style2 +
    ";font-size:85%;white-space: nowrap;'>" +
    value2 +
    "</text>";

  return h("div", {
    innerHTML: str,
    style: "overflow:hidden;line-height:18px;",
  });
};

//金额格式化  带￥符号，字体加粗
export const tab_MoneyFormat = (row, column, cellValue) => {
  if (cellValue == null || cellValue == undefined) return "-";

  const resArr = priceFormat(cellValue || 0).split(".");
  // let str = `<text style='font-size:70%'>￥</text><text>${resArr[0]}</text><text style='font-size:80%'>.${resArr[1]}</text>`;
  let str = `<text>${resArr[0]}</text><text style='font-size:80%'>.${resArr[1]}</text>`;
  return h("div", {
    style: "font-weight:600;color:#f00",
    innerHTML: str,
  });
};

//金额格式化  仅格式化金额，保留两位小数
export const tab_PriceFormat = (row, column, cellValue) => {
  if (cellValue == null || cellValue == undefined) return "-";

  return priceFormat(cellValue || 0);
};

//多行文本框格式化
export const tab_TextAreaFormat = (row, column, cellValue) => {
  return h("div", {
    style:
      "display: -webkit-box;-webkit-line-clamp:2;-webkit-box-orient: vertical;overflow: hidden;text-overflow: ellipsis;white-space: normal;overflow-wrap: break-word;",
    innerHTML: cellValue || "-",
  });
};

//手机号脱敏
export const phoneFormat = (phone) => {
  // 校验：非11位手机号直接返回原数据（避免错误替换）
  if (!/^1[3-9]\d{9}$/.test(phone)) {
    return phone; // 或返回空/提示，根据业务需求调整
  }
  // 正则替换：保留前3位和后4位，中间4位替换为****
  return phone.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2");
};

//身份证号脱敏
export const idCardForamt = (idCard) => {
  if (!idCard || idCard.length < 8) return idCard;
  return idCard.slice(0, 6) + "*".repeat(idCard.length - 10) + idCard.slice(-4);
};

//验证空值，但不限于数字0
export const judgeNullExceptZero = (value) => {
  if (value == null || value == undefined || value == "") return true;
  else return false;
};
